<template>
  <div class="content-group">
    <div class="contents-row">
      <!-- 타이틀 시작 -->
      <div class="page-title-1depth">
        <span class="page-title-1depth-text">{{$t('sm.adminGroupSettings_page_menuPrivilegeSetting')}}</span>
      </div>
      <!-- 컨텐츠 옵션 시작 -->
      <div v-if="checkInhritView"
           class="contents-title-option-group">
        <q-radio @input="onInput" v-model="adminGeneral.admin_menu_inhrit_yn"
                 val="1" color="primary" :label="this.$t('sm.adminGroupSettings_page_admin_inhrit_yn1')" class="bs bs-q-radio bs-q-radio-square" :disable="isReadOnly || fnIsSuper">
        </q-radio>
        <q-radio @input="onInput" v-model="adminGeneral.admin_menu_inhrit_yn"
                 val="0" color="primary" :label="this.$t('sm.adminGroupSettings_page_admin_inhrit_yn2')" class="bs bs-q-radio bs-q-radio-square" :disable="isReadOnly || fnIsSuper">
        </q-radio>
      </div>
      <!-- 컨텐츠 옵션 끝 -->
      <!-- 타이틀 끝 -->
    </div>

    <div class="portlet">

      <div class="contents-row">
        <!-- 테이블 시작 -->
        <div class="contents-row collapsible-fullH  ps-q-treeBlock no-border">
          <q-list inset-separator class="bs bs-q-collapsible bs-q-collapsible-fullH borderColorGray">
            <q-tree
              ref="authMenuTree"
              :nodes="adminMenuTree"
              node-key="menu_id"
              :dark="dark"
              :filter="filter"
              :tick-strategy="tickStrategy"
              :ticked.sync="ticked"
              :defaultExpandAll = "defaultExpandAll"
              :selected.sync = selected
              :expanded.sync = expanded
              class="ps-q-tree ps-q-tree-square"
              style="minHeight: 400px;"
            >
              <div slot="header-custom" slot-scope="prop" class="row items-center">
                <div>
                  {{prop.node.label}}
                </div>
                <q-select class="bs bs-q-select bs-q-select-default marR15" style="width:160px;"
                  v-model = "prop.node.admin_menu_role_type"
                  :options="selectOptions"
                  @input="onChangeRw(prop.node)"
                ></q-select>
              </div>
            </q-tree>
          </q-list>
        </div>
        <!-- 테이블 끝 -->
      </div>

    </div>

  </div>
</template>
<script>
  import {setChildValChange, arrParentNodesRoleChange} from '~/utils/admin-common'
  import {createNamespacedHelpers} from 'vuex'
  const {mapState, mapActions, mapMutations} = createNamespacedHelpers('system/adminSettings/adminGroupSettings')

  export default {
    name: 'AdminMenuGroup',
    props: {
      fnIsSuper: {
        type: Boolean,
        default: false
      },
      // 관리자별 관리장비 그룹편집
      isPathView: {
        type: Boolean,
        default: false
      },
      isReadOnly: {
        type: Boolean,
        default: false
      },
      externalAuth: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState([
        'adminMenuSel',
        'oldAdminMenuParent',
        'adminMenuParent',
        'adminMenuTree',
        'adminMenuExpanded',
        'adminGeneral',
        'adminMenuCurr'
      ]),
      checkInhritView () {
        return this.adminGeneral.parent_admin_id !== null && this.adminGeneral.admin_type !== 2 && this.adminGeneral.admin_type !== 3 && !this.externalAuth
      }
    },
    created () {
      this.fnSelectChange()
      this.getTicked()
    },
    data () {
      return {
        option: null,
        terms: null,
        pageIndex: 1,
        pageSize: 15,
        page: 1,
        filter: null,
        tickStrategy: 'leaf-filtered',
        ticked: [],
        selectableNodes: true,
        dark: false,
        accordion: true,
        selected: null,
        expanded: null,
        defaultExpandAll: true,
        admin_menu_inhrit_yn: '1',
        selectOptions: [
          {label: this.$t('cmn.read'), value: 0},
          {label: this.$t('cmn.readAndwrite'), value: 1}
        ],
        tempAdminMenuParent: []
      }
    },
    methods: {
      ...mapActions([
        'acsMenuTree'
      ]),
      ...mapMutations([
        'mutationMenuTree'
      ]),
      onSave () {
        this.$emit('onSave')
      },
      onChange () {},
      onInput () {
        this.fnSelectChange()
        this.getTicked()
      },
      fnSelectChange (val) {
        if (val === undefined) {
          val = this.adminMenuParent
        }
        if (this.adminGeneral.admin_menu_inhrit_yn === '1') {
          this.setTreeItemValueChange(val, this.oldAdminMenuParent)
        } else {
          this.setTreeItemValueChange(val, this.adminMenuCurr)
        }
      },
      getTicked (val) {
        if (val === undefined) {
          val = this.adminMenuParent
        }
        if ((this.adminMenuTree !== undefined && this.isReadOnly) ||
          (this.adminMenuTree !== undefined && this.adminGeneral.admin_menu_inhrit_yn === '1')) {
          this.adminMenuTree.forEach(item => {
            item.disabled = true
          })
        } else {
          this.adminMenuTree.forEach(item => {
            item.disabled = null
          })
        }
        if (this.adminGeneral.admin_menu_inhrit_yn === '1') {
          this.ticked = val.map((item) => {
            return item.menu_id
          })
        // 개별 속성
        } else if (this.adminGeneral.admin_menu_inhrit_yn === '0') {
          if (this.adminMenuCurr.length <= 0) {
            this.ticked = val.map((item) => {
              return item.menu_id
            })
          } else {
            this.ticked = this.adminMenuCurr.map((item) => {
              return item.menu_id
            })
          }
        }
      },
      // 메뉴 읽기/쓰기 변경
      onChangeRw (v) {
        if (v.admin_menu_role_type === 1) {
          arrParentNodesRoleChange(this.adminMenuTree, {id: 'menu_id', val: v.menu_id}, v.admin_menu_role_type)
        }
        setChildValChange(v, {admin_menu_role_type: v.admin_menu_role_type})
      },
      setTreeItemValueChange (v, chng) {
        v.forEach(item => {
          chng.forEach(row => {
            if (item.menu_id === row.menu_id) {
              item.admin_menu_role_type = row.admin_menu_role_type
            }
          })
        })
        return v
      }
    },
    watch: {
      adminMenuParent (val) {
        this.fnSelectChange(val)
        this.getTicked(val)
      }
    }
  }
</script>

<style scoped>
  .q-tree-node .devTypemenuTree {
    width: 100%;
  }

</style>
